import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const AmazonDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <defs>
      <clipPath id="amazon1-1_svg__a">
        <path
          data-name="\u9577\u65B9\u5F62 803"
          transform="translate(68.86 283.644)"
          fill="#fff"
          stroke="#707070"
          d="M0 0h108v64H0z"
        />
      </clipPath>
    </defs>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 331" transform="translate(-43.86 -144.644)">
      <rect
        data-name="\u9577\u65B9\u5F62 784"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(43.86 144.644)"
      />
      <path data-name="\u9577\u65B9\u5F62 785" fill="#fff" d="M50.141 184.298h131.78v74.423H50.141z" />
      <path
        data-name="\u30D1\u30B9 1037"
        d="M50.141 256.872v167.012a14.308 14.308 0 0014.309 14.308h103.1a14.308 14.308 0 0014.309-14.308V256.872z"
        fill="#fff"
      />
      <g
        data-name="\u9577\u65B9\u5F62 804"
        transform="translate(55.464 236.304)"
        fill="none"
        stroke="#bfbfbf"
        strokeWidth={0.5}
      >
        <rect width={90} height={90} rx={10} stroke="none" />
        <rect x={-0.25} y={-0.25} width={90.5} height={90.5} rx={10.25} />
      </g>
      <g data-name="\u30B0\u30EB\u30FC\u30D7 328">
        <path
          data-name="\u30D1\u30B9 1036"
          d="M181.894 198.3v-32.013a14.3 14.3 0 00-14.282-14.309h-14.1v1.922a7.579 7.579 0 01-7.572 7.586H86.931a7.579 7.579 0 01-7.572-7.586v-1.918H64.424a14.3 14.3 0 00-14.283 14.309V198.3z"
          fill="#fff"
        />
      </g>
      <rect
        data-name="\u9577\u65B9\u5F62 786"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(97.566 430.669)"
      />
      <path data-name="\u7DDA 7" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M50.267 198.818h131.364" />
      <rect
        data-name="\u9577\u65B9\u5F62 787"
        width={90}
        height={90}
        rx={10}
        transform="translate(55.464 236.304)"
        fill="#fc3"
      />
      <path data-name="\u9577\u65B9\u5F62 790" fill="#eee" d="M58.328 167.194h113.045v4H58.328z" />
      <path data-name="\u9577\u65B9\u5F62 800" fill="#eee" d="M58.328 207.194h53.045v10H58.328z" />
      <path data-name="\u9577\u65B9\u5F62 798" fill="#eee" d="M58.328 180.194h113.045v4H58.328z" />
      <path data-name="\u9577\u65B9\u5F62 791" fill="#eee" d="M58.328 173.892h92.422v4H58.328z" />
      <path data-name="\u9577\u65B9\u5F62 799" fill="#eee" d="M58.328 186.892h50.422v4H58.328z" />
      <path data-name="\u9577\u65B9\u5F62 801" fill="#eee" d="M58.328 219.892h80v4h-80z" />
      <path data-name="\u9577\u65B9\u5F62 792" fill="#e5e5e5" d="M54.837 362.008h58.26v58.26h-58.26z" />
      <path data-name="\u9577\u65B9\u5F62 805" fill="#e5e5e5" d="M118.475 362.008h58.26v58.26h-58.26z" />
      <path data-name="\u9577\u65B9\u5F62 793" fill="#eee" d="M57.328 340.999h66.045v3.938H57.328z" />
      <path data-name="\u9577\u65B9\u5F62 794" fill="#eee" d="M57.328 347.696H99.75v3.938H57.328z" />
      <g
        data-name="\u30DE\u30B9\u30AF\u30B0\u30EB\u30FC\u30D7 1"
        transform="translate(-22 4)"
        clipPath="url(#amazon1-1_svg__a)"
      >
        <rect
          data-name="\u9577\u65B9\u5F62 802"
          width={90}
          height={90}
          rx={10}
          transform="translate(77.464 232.304)"
          fill="#fff"
        />
      </g>
      <path data-name="\u9577\u65B9\u5F62 806" fill="#eee" d="M60.328 294.999h66.045v3.938H60.328z" />
      <path data-name="\u9577\u65B9\u5F62 807" fill="#eee" d="M60.328 301.696h42.422v3.938H60.328z" />
    </g>
  </Root>
);

const Root = styled('svg')();

export default AmazonDevice11;
